/* Free gifts in the cart: the reconciler.

   Reads the tiers from the <anyra-gift-pick> element the drawer renders and,
   after every cart change, brings the gift lines in step with the cart:
     a gift whose tier the cart no longer reaches is removed
     a gift at more than one is put back to one
     a gift the store did not price at zero is removed (no discount rule)
     the 1,499 serum is added on its own once the tier is reached
     the 699 lip gift: picked by the customer, or (Rs 0 mode, 19 Oct) a random in-stock one added on its own
       when the cart reaches the tier with none picked; the picker still swaps it, a removal is respected
   Gift lines are the ones carrying the property _anyra_gift.

   Loaded from the section head (cart-drawer.liquid, main-cart.liquid), never
   from the snippet: the body arrives through innerHTML on every change and a
   script tag that arrives that way does not run.

   Loop safety. A pass mutates only the diff, so the pass after it finds
   nothing to do; that is the terminator. On top: one pass at a time with a
   pending re-run, a streak counter that only counts passes our own publish
   triggered, our own requests carry ?anyra_gift=1, and a tier that came back
   priced above zero is not retried in this page. While a pass is running the
   cart controls are locked, because the theme mutates lines by their 1-based
   index and our removal would shift them under an in-flight click.

   The customer's own removal of a gift is respected: Shopify line keys are
   deterministic (variant + properties), so a removal we did is remembered
   only until the next pass sees that key gone, after which the same key
   disappearing again means the customer did it. */
(() => {
  if (window.AnyraGiftPick) return;
  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const KEY = 'anyra_gift_declined';
  const ON_CART_PAGE = !!document.querySelector('main-cart');
  const S = {
    busy: false, pending: false, pendingPick: null,
    selfTriggered: false, streak: 0, halted: false,
    noRule: (() => { try { return JSON.parse(sessionStorage.getItem('anyra_gift_norule') || '{}'); } catch (e) { return {}; } })(),
    lastKey: {}, expectGone: {},
  };

  const declined = () => { try { return JSON.parse(sessionStorage.getItem(KEY) || '{}'); } catch (e) { return {}; } };
  const setDeclined = (tier, on) => { try { const d = declined(); if (on) d[tier] = true; else delete d[tier]; sessionStorage.setItem(KEY, JSON.stringify(d)); } catch (e) { /* storage blocked */ } };

  const el = () => document.querySelector('anyra-gift-pick');
  const cfg = () => {
    const e = el();
    if (!e) return null;
    return {
      t2: parseInt(e.dataset.t2 || '0', 10),
      t3: parseInt(e.dataset.t3 || '0', 10),
      v3: parseInt(e.dataset.t3Variant || '0', 10),
      v2: (e.dataset.t2Variants || '').split(',').filter(Boolean).map(Number),
      // Rs 0 gift products are configured (15 Oct): no discount rule, so a paid lip is just a paid lip.
      free: e.dataset.giftFree === '1',
      // First tier-2 gift whose (real) product is in stock: the one the 1,499 co-add uses.
      first: parseInt(e.dataset.t2First || '0', 10),
      // Free mode only: tier-2 gifts whose real product is in stock, and whether the real serum is sold out.
      avail2: e.dataset.t2Avail ? e.dataset.t2Avail.split(',').filter(Boolean).map(Number) : null,
      soldout3: e.dataset.t3Soldout === '1',
    };
  };

  const sid = () => {
    const ev = new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: [] } });
    document.documentElement.dispatchEvent(ev);
    const ids = ev.detail.sections;
    if (ids && ids.length) return ids;
    const d = document.querySelector('cart-drawer');
    return d && d.dataset.sectionId ? [d.dataset.sectionId] : [];
  };

  const lock = (on) => document.documentElement.classList.toggle('anyra-gift-busy', !!on);

  const json = async (url, opts) => {
    const r = await fetch(url, Object.assign({ headers: { 'Content-Type': 'application/json', Accept: 'application/json' } }, opts || {}));
    const body = await r.json().catch(() => ({}));
    if (!r.ok) { const err = new Error(body.description || body.message || ('HTTP ' + r.status)); err.body = body; throw err; }
    return body;
  };
  const getCart = () => json(ROOT + 'cart.js');
  const change = (key, quantity) => json(ROOT + 'cart/change.js?anyra_gift=1', { method: 'POST', body: JSON.stringify({ id: key, quantity, sections: sid() }) });
  const add = (variant, tier) => json(ROOT + 'cart/add.js?anyra_gift=1', { method: 'POST', body: JSON.stringify({ items: [{ id: variant, quantity: 1, properties: { _anyra_gift: String(tier) } }], sections: sid() }) });

  const analyse = (cart) => {
    const gifts = (cart.items || []).filter((i) => i.properties && i.properties._anyra_gift);
    const byTier = (t) => gifts.filter((i) => String(i.properties._anyra_gift) === String(t));
    const giftTotal = gifts.reduce((s, i) => s + (i.final_line_price || 0), 0);
    // One of the four lip products bought as a normal line. The 1,499 rule
    // frees the two cheapest of the five gift products, so a bought lip plus
    // our gift lip would be the two it frees and the serum would be charged
    // (client, 24 Sep checkout: two free lip oils, no serum).
    const c = cfg();
    const lipIds = c ? c.v2 : [];
    const paidLip = c && c.free ? [] : (cart.items || []).filter((i) => !(i.properties && i.properties._anyra_gift) && lipIds.includes(i.variant_id));
    return { g2: byTier(2), g3: byTier(3), paidLip, base: (cart.total_price || 0) - giftTotal };
  };

  // Hand the new state to the theme, which swaps the drawer and fires
  // cart:updated. On the cart page the table is index-bound markup we do not
  // own, so the page reloads instead.
  const publish = (cart) => {
    if (ON_CART_PAGE) { window.location.reload(); return; }
    S.selfTriggered = true;
    if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.PUB_SUB_EVENTS && cart.sections) {
      FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart, source: 'anyra-gift' });
    } else {
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: false } }));
    }
  };

  // A tier found unpriced stays known across reloads, so /cart (which reloads after each change) cannot loop.
  const saveNoRule = () => { try { sessionStorage.setItem('anyra_gift_norule', JSON.stringify(S.noRule)); } catch (e) { /* storage blocked */ } };

  // Remove a gift line and remember that we did.
  const drop = async (key) => { S.expectGone[key] = true; return change(key, 0); };

  // After an add: if the store did not zero the line, take it straight back
  // out before anyone sees it, and stop trying this tier on this page.
  const settle = async (tier, lastResponse) => {
    const fresh = await getCart();
    const a = analyse(fresh);
    const line = (tier === 2 ? a.g2 : a.g3)[0];
    // A tier-2 line added alongside the serum is priced by the tier-3 rule,
    // so judging it on its own would remove a gift the store did price at zero.
    if (tier === 2 && a.g3.length && line && (line.final_line_price || 0) === 0) { S.lastKey[2] = line.key; }
    let last = lastResponse;
    if (line && (line.final_line_price || 0) > 0) {
      console.warn('[anyra-gift] tier ' + tier + ' is not priced at zero by the store (no discount rule); gift removed');
      S.noRule[tier] = true;
      last = await drop(line.key);
      // No serum rule means the lip added with it is not free either: never leave a charged "free" lip behind.
      if (tier === 3) for (const g of a.g2) if ((g.final_line_price || 0) > 0) last = await drop(g.key);
      const again = await getCart();
      if (last && last.sections) again.sections = last.sections;
      return again;
    }
    if (line) S.lastKey[tier] = line.key;
    if (last && last.sections) fresh.sections = last.sections;
    return fresh;
  };

  async function reconcile(cart) {
    if (S.halted) return;
    if (S.busy) { S.pending = true; return; }
    const c = cfg();
    if (!c || !cart || cart.errors || !Array.isArray(cart.items)) return;
    const self = S.selfTriggered; S.selfTriggered = false;
    S.busy = true; lock(true);
    let mutated = false;
    let last = null;
    try {
      // Rs 0 gift products (15 Oct, for the GST invoices). A zero-priced line is only ever a gift: one that arrived
      // without the gift property (its own page, a cart link) belongs to no offer, and a gift line whose product is
      // not the one configured for its tier is a leftover from before a settings change. Both go first, so a
      // leftover is never read as a missing discount rule by the price checks below. The store sells nothing else
      // at Rs 0 (checked 15 Oct), and a discounted line keeps its original price, so paid products are never hit.
      {
        let swept = false;
        for (const i of cart.items) {
          const gt = i.properties && i.properties._anyra_gift ? String(i.properties._anyra_gift) : '';
          const known = gt === '2' || gt === '3';
          // No tier, or a tier value we never write ('9', ' 2'): not a gift of ours.
          const stray = (!known && (i.original_price || 0) === 0) || (gt !== '' && !known);
          const stale = (gt === '2' && c.v2.length > 0 && !c.v2.includes(i.variant_id))
            || (gt === '3' && c.v3 > 0 && i.variant_id !== c.v3)
            // Free mode: a gift whose real product sold out cannot ship.
            || (c.free && gt === '2' && c.avail2 && !c.avail2.includes(i.variant_id))
            || (c.free && gt === '3' && c.soldout3);
          if (stray || stale) { last = await drop(i.key); mutated = true; swept = true; }
        }
        if (swept) cart = await getCart();
      }
      const a = analyse(cart);

      // A customer who removed a gift while qualifying keeps it out, but only
      // until the cart drops below that tier. Crossing the line again is a new
      // decision and the gift comes back on its own. Client, 23 Sep 18:07:
      // "the Rose & Seed Serum is still not getting added automatically when
      // the free gift is unlocked; it is asking me to add it manually." In
      // testing, one removal used to switch the auto-add off for the whole
      // browsing session.
      {
        const dd = declined();
        if (dd[2] && (!c.t2 || a.base < c.t2)) setDeclined(2, false);
        if (dd[3] && (!c.t3 || a.base < c.t3)) setDeclined(3, false);
        // Same for a tier we judged unpriced: below the line there is nothing
        // to judge, so the next crossing gets a fresh try instead of an
        // Add It button that no longer works.
        if (S.noRule[2] && (!c.t2 || a.base < c.t2)) S.noRule[2] = false;
        if (S.noRule[3] && (!c.t3 || a.base < c.t3)) S.noRule[3] = false;
      }

      // One Minis set per order (client, 23 Sep). The set page refuses a
      // second add and the drawer has no stepper on it; this catches the rest,
      // for example a second tab.
      {
        const sets = (cart.items || []).filter((i) => i.handle === 'anyra-minis');
        if (sets.length) {
          for (const extra of sets.slice(1)) { last = await change(extra.key, 0); mutated = true; }
          if (sets[0].quantity > 1) { last = await change(sets[0].key, 1); mutated = true; }
        }
      }

      // Anything beyond one line per tier goes.
      for (const extra of a.g2.slice(1).concat(a.g3.slice(1))) { last = await drop(extra.key); mutated = true; }

      // At the top tier a lip product the customer bought IS their lip gift:
      // the rule frees it with the serum. A gift lip on top of it would push
      // the serum out, so it goes (not a decline, it is replaced by theirs).
      const ownLip = c.t3 && a.base >= c.t3 && a.paidLip.length > 0;
      if (ownLip && a.g2.length) {
        for (const g of a.g2) { last = await drop(g.key); mutated = true; }
        a.g2 = [];
      }

      const declinedNow = {};
      for (const [tier, lines, threshold] of [[2, a.g2, c.t2], [3, a.g3, c.t3]]) {
        const g = lines[0];
        if (g) {
          delete S.expectGone[g.key];
          if (!threshold || a.base < threshold) {
            last = await drop(g.key); mutated = true;
          } else if (g.quantity > 1) {
            // Quantity first: one free plus one charged is not a missing rule.
            last = await change(g.key, 1); mutated = true;
          } else if ((g.final_line_price || 0) > 0) {
            // At the top tier his rule frees TWO lines, so a lip gift sitting
            // alone above 1,499 is priced only because the serum is not in yet.
            // Let the serum add below and judge them together on the next pass.
            if (tier === 2 && c.t3 && a.base >= c.t3 && !a.g3.length && c.v3 && !S.noRule[3] && !declined()[3]) {
              S.lastKey[tier] = g.key;
            } else {
              console.warn('[anyra-gift] tier ' + tier + ' is not priced at zero by the store (no discount rule); gift removed, not retried');
              S.noRule[tier] = true;
              last = await drop(g.key); mutated = true;
            }
          } else {
            S.lastKey[tier] = g.key;
          }
        } else if (S.lastKey[tier]) {
          const key = S.lastKey[tier];
          S.lastKey[tier] = null;
          if (S.expectGone[key]) {
            delete S.expectGone[key]; // our removal, now confirmed gone
          } else if (threshold && a.base >= threshold) {
            // The customer took it out while still qualifying: do not put it back.
            setDeclined(tier, true);
            declinedNow[tier] = true;
          }
        }
      }

      // The gifts add themselves.
      //
      // Client, 23 Sep: "Once the order total goes above 1,499 the serum
      // should be added automatically. Right now it only gets added if I
      // manually click Add It, which could create unnecessary friction."
      //
      // The reason it did not was his own discount rule: at 1,499 it gives
      // TWO items free from the five gift products, so a cart holding only
      // the serum has one eligible line, Shopify applies nothing, the serum
      // comes back at full price and the guard below removes it rather than
      // charge for a gift. So at the top tier both gifts go in together: the
      // serum, and the first lip product if the customer has not picked one.
      // The picker still lets them change the lip choice afterwards.
      const d = declined();
      let added2 = false, lastTier = 3;
      if (c.t3 && c.v3 && a.base >= c.t3 && !a.g3.length && !S.noRule[3] && !d[3] && !declinedNow[3]) {
        try {
          if (!ownLip && !a.g2.length && c.first && !d[2] && !declinedNow[2] && !S.noRule[2]) {
            // Its own try: a sold-out lip must not stop the serum going in.
            try { last = await add(c.first, 2); added2 = true; } catch (e) { console.warn('[anyra-gift] lip co-add failed:', e.message); }
          }
          last = await add(c.v3, 3);
          mutated = true;
        } catch (e) { console.warn('[anyra-gift] gift add failed:', e.message); S.noRule[3] = true; }
      }

      // Client, 15 and 19 Oct: "if a customer reaches 699 and doesn't select a free gift, a lip essential is
      // automatically added at random". Rs 0 mode only (the gift is its own product, no discount to judge). A
      // customer who removed the gift is left alone until the cart drops below the tier (declined(), above).
      if (c.free && c.t2 && a.base >= c.t2 && !a.g2.length && !added2 && !ownLip
          && !d[2] && !declinedNow[2] && !S.noRule[2]) {
        const pool = (c.avail2 && c.avail2.length) ? c.avail2 : (c.first ? [c.first] : []);
        if (pool.length) {
          const pick = pool[Math.floor(Math.random() * pool.length)];
          try { last = await add(pick, 2); mutated = true; lastTier = 2; } catch (e) { console.warn('[anyra-gift] auto lip gift failed:', e.message); }
        }
      }

      if (mutated) {
        S.streak = self ? S.streak + 1 : 1;
        if (S.streak >= 4) { S.halted = true; console.warn('[anyra-gift] four self-triggered passes in a row, stopping'); }
        let fresh;
        if (last && last.items && !last.token) {
          // add.js answered (no cart in the body): verify the price before showing it
          fresh = await settle(lastTier, last);
        } else {
          fresh = await getCart();
          if (last && last.sections) fresh.sections = last.sections;
          const after = analyse(fresh);
          if (after.g2[0]) S.lastKey[2] = after.g2[0].key;
          if (after.g3[0]) S.lastKey[3] = after.g3[0].key;
        }
        publish(fresh);
      } else {
        S.streak = 0;
      }
    } catch (e) {
      console.warn('[anyra-gift]', e.message || e);
    } finally {
      S.busy = false; lock(false);
      saveNoRule();
      if (S.pendingPick) { const pp = S.pendingPick; S.pendingPick = null; pick(pp.tier, pp.variant, pp.button); }
      else if (S.pending) { S.pending = false; getCart().then(reconcile).catch(() => {}); }
    }
  }

  // The customer's pick (699) or a re-add (1,499).
  async function pick(tier, variant, button) {
    const c = cfg();
    if (!c) return;
    if (tier === 2 && !c.v2.includes(variant)) return;
    if (tier === 3 && variant !== c.v3) return;
    if (S.busy) { S.pendingPick = { tier, variant, button }; return; }
    if (S.noRule[tier]) { console.warn('[anyra-gift] tier ' + tier + ' has no discount rule; pick ignored'); return; }
    S.busy = true; lock(true);
    if (button) button.disabled = true;
    try {
      const cart = await getCart();
      const a = analyse(cart);
      const threshold = tier === 2 ? c.t2 : c.t3;
      if (!threshold || a.base < threshold) { if (button) button.disabled = false; return; }
      // A bought lip product already takes the lip slot at the top tier.
      if (tier === 2 && c.t3 && a.base >= c.t3 && a.paidLip.length) { if (button) button.disabled = false; return; }
      let last = null;
      for (const g of (tier === 2 ? a.g2 : a.g3)) { last = await drop(g.key); }
      last = await add(variant, tier);
      setDeclined(tier, false);
      const fresh = await settle(tier, last);
      S.streak = 0;
      publish(fresh);
    } catch (e) {
      console.warn('[anyra-gift] pick failed:', e.message || e);
      if (button) button.disabled = false;
    } finally {
      S.busy = false; lock(false);
      saveNoRule();
      if (S.pending) { S.pending = false; getCart().then(reconcile).catch(() => {}); }
    }
  }

  // Desktop arrows on the gift row (Atharva, 8 Oct: on a laptop only the first two of four gifts were reachable,
  // a mouse cannot swipe). The rail gets has-overflow, at-start and at-end; CSS shows the arrows on a fine pointer.
  const navState = (rail) => {
    const ul = rail && rail.querySelector('[data-gpick-options]');
    if (!ul) return;
    rail.classList.toggle('has-overflow', ul.scrollWidth > ul.clientWidth + 4);
    const atStart = ul.scrollLeft <= 2, atEnd = ul.scrollLeft + ul.clientWidth >= ul.scrollWidth - 2;
    rail.classList.toggle('at-start', atStart);
    rail.classList.toggle('at-end', atEnd);
    // Disabled, not just hidden: an invisible arrow would let a click fall through to the gift under it.
    const prev = rail.querySelector('.anyra-gpick__nav--prev'), next = rail.querySelector('.anyra-gpick__nav--next');
    if (prev) prev.disabled = atStart;
    if (next) next.disabled = atEnd;
  };
  const navAll = () => document.querySelectorAll('.anyra-gpick__rail').forEach(navState);
  let navQueued = false;
  const navSoon = () => { if (navQueued) return; navQueued = true; requestAnimationFrame(() => { navQueued = false; navAll(); }); };
  document.addEventListener('scroll', (e) => { const t = e.target; if (t && t.matches && t.matches('[data-gpick-options]')) navState(t.closest('.anyra-gpick__rail')); }, true);
  document.addEventListener('pointerover', (e) => { const r = e.target.closest && e.target.closest('.anyra-gpick__rail'); if (r) navState(r); });
  window.addEventListener('resize', navSoon);
  const watchCart = () => document.querySelectorAll('cart-drawer, main-cart').forEach((n) => new MutationObserver(navSoon).observe(n, { childList: true, subtree: true, attributes: true, attributeFilter: ['open', 'class'] }));

  document.addEventListener('click', (e) => {
    const nav = e.target.closest('[data-gpick-scroll]');
    if (nav) {
      e.preventDefault();
      const ul = nav.closest('.anyra-gpick__rail')?.querySelector('[data-gpick-options]');
      if (ul) {
        const li = ul.querySelector(':scope > li');
        const gap = parseFloat(getComputedStyle(ul).columnGap) || 10;
        const step = li ? li.getBoundingClientRect().width + gap : ul.clientWidth * 0.8;
        ul.scrollBy({ left: step * parseInt(nav.dataset.gpickScroll, 10), behavior: 'smooth' });
      }
      return;
    }
    const addBtn = e.target.closest('[data-gpick-add]');
    if (addBtn) { e.preventDefault(); pick(parseInt(addBtn.dataset.tier, 10), parseInt(addBtn.dataset.variant, 10), addBtn); return; }
    const changeBtn = e.target.closest('[data-gpick-change]');
    if (changeBtn) { e.preventDefault(); const tier = changeBtn.closest('[data-gpick-tier]'); if (tier) tier.classList.toggle('is-choosing'); navSoon(); }
  });

  document.addEventListener('cart:updated', (e) => { const cart = e.detail && e.detail.cart; if (cart) reconcile(cart); });
  const boot = () => { watchCart(); navSoon(); getCart().then((cart) => { if (el()) reconcile(cart); }).catch(() => {}); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  class AnyraGiftPick extends HTMLElement {}
  if (!customElements.get('anyra-gift-pick')) customElements.define('anyra-gift-pick', AnyraGiftPick);
  window.AnyraGiftPick = { reconcile, pick };
})();
